/** Kannada: the job between two phones: questions, details, the price plan, statuses, offers, signing, notes. */
export const job = {
    "question.problem": "ಏನು ಹಾಳಾಗಿದೆ? ಸ್ವಲ್ಪ ವಿವರವಾಗಿ ಹೇಳಿ.",
    "question.rooms": "ಎಷ್ಟು ಕೋಣೆಗಳು, ಮತ್ತು ಯಾವ ಕೆಲಸಗಳು?",
    "question.area_sqft": "ಸುಮಾರು ಎಷ್ಟು ಚದರ ಅಡಿ, ಒಳಗೆ ಅಥವಾ ಹೊರಗೆ?",
    "question.people": "ಮನೆಯಲ್ಲಿ ಎಷ್ಟು ಜನ ಇದ್ದಾರೆ?",
    "question.meals": "ಯಾವ ಯಾವ ಹೊತ್ತಿನ ಅಡುಗೆ ಮಾಡಬೇಕು?",
    "question.pets": "ಮನೆಯಲ್ಲಿ ಸಾಕು ಪ್ರಾಣಿ ಇದೆಯೇ?",
    "question.route": "ಎಲ್ಲಿಂದ ಎಲ್ಲಿಗೆ, ಮತ್ತು ಎಷ್ಟು ಸಮಯ?",
    "question.labour_only": "ಪೇಂಟ್ ನೀವೇ ಖರೀದಿಸುತ್ತೀರಾ?",
    "question.frequency": "ಎಷ್ಟು ಸಲ ಬರಬೇಕು: ಪ್ರತಿದಿನ, ದಿನ ಬಿಟ್ಟು ದಿನ, ಅಥವಾ ವಾರಕ್ಕೊಮ್ಮೆ?",
    "question.hours": "ದಿನಕ್ಕೆ ಎಷ್ಟು ಗಂಟೆ?",
    "question.coats": "ಪೇಂಟ್ ಎಷ್ಟು ಕೋಟ್?",
    "detail.problem": "ಸಮಸ್ಯೆ",
    "detail.rooms": "ಕೋಣೆಗಳು",
    "detail.area_sqft": "ಜಾಗದ ಅಳತೆ",
    "detail.people": "ಜನ",
    "detail.meals": "ಊಟ",
    "detail.pets": "ಸಾಕು ಪ್ರಾಣಿ",
    "detail.route": "ದಾರಿ",
    "detail.labour_only": "ಪೇಂಟ್ ನೀವೇ ಖರೀದಿಸುತ್ತೀರಿ",
    "detail.frequency": "ಎಷ್ಟು ಸಲ",
    "detail.hours": "ದಿನಕ್ಕೆ ಗಂಟೆಗಳು",
    "detail.coats": "ಪೇಂಟ್ ಕೋಟ್‌ಗಳು",
    "reason.band": "ಇಲ್ಲಿ ಈ ಕೆಲಸಕ್ಕೆ ಚಾಲ್ತಿ ದರ {low}–{high}.",
    "reason.scope": "{item}: {percent}% ಹೆಚ್ಚು.",
    "reason.history": "ಹಿಂದೆ ಈ ಕೆಲಸಕ್ಕೆ ನಿಮಗೆ ಸುಮಾರು {median} ಸಿಕ್ಕಿದೆ ({count} ಕೆಲಸಗಳು).",
    "reason.floor": "ನಿಮ್ಮ ಸ್ವಂತ ಕನಿಷ್ಠ ಬೆಲೆ {floor}.",
    "reason.plan": "{opening} ರಿಂದ ಶುರು ಮಾಡುತ್ತೇವೆ, {limit} ಗಿಂತ ಕಡಿಮೆ ಹೋಗುವುದಿಲ್ಲ.",
    "status.draft": "ಕಳಿಸುತ್ತಿದೆ",
    "status.sent": "ಕೇಳಲಾಗಿದೆ",
    "status.clarifying": "ಪ್ರಶ್ನೆ ಕೇಳಲಾಗಿದೆ",
    "status.responded": "ಉತ್ತರ ಬಂದಿದೆ",
    "status.negotiating": "ಏಜೆಂಟ್‌ಗಳು ಚೌಕಾಸಿ ಮಾಡುತ್ತಿವೆ",
    "status.confirming": "ಸಹಿಗೆ ಕಾಯುತ್ತಿದೆ",
    "status.agreed": "ಒಪ್ಪಂದವಾಗಿದೆ",
    "status.in_progress": "ದಾರಿಯಲ್ಲಿ",
    "status.delivered": "ಕೆಲಸ ಮುಗಿದಿದೆ",
    "status.revision": "ಸರಿ ಮಾಡುತ್ತಿದ್ದಾರೆ",
    "status.closed": "ಮುಕ್ತಾಯ",
    "status.declined": "ಬೇಡ ಎಂದರು",
    "status.expired": "ಅವಧಿ ಮೀರಿದೆ",
    "status.cancelled": "ರದ್ದಾಗಿದೆ",
    "cancel.no_match": "ಈ ರೀತಿಯ ಕೆಲಸ ಮಾಡುವುದಿಲ್ಲ, ಅಥವಾ ಈ ಏರಿಯಾಕ್ಕೆ ಬರುವುದಿಲ್ಲ",
    "cancel.no_deal": "ಇಬ್ಬರ ಮಿತಿಯೊಳಗೆ ಬೆಲೆ ಸಿಗಲಿಲ್ಲ",
    "cancel.declined_by_owner": "ಒಪ್ಪಲಿಲ್ಲ",
    "cancel.taken": "ಬೇರೆ ಕೆಲಸಗಾರರೊಂದಿಗೆ ಬುಕ್ ಆಗಿದೆ",
    "cancel.other": "ರದ್ದಾಗಿದೆ",
    "job.customer": "ಗ್ರಾಹಕರು",
    "job.worker": "ಕೆಲಸಗಾರರು",
    "job.signed": "ಸಹಿ: {price}",
    "job.both_signed": "ಇಬ್ಬರೂ ಸಹಿ ಮಾಡಿದ್ದಾರೆ",
    "job.their_signature": "ಅವರ ಸಹಿಗಾಗಿ ಕಾಯಲಾಗುತ್ತಿದೆ",
    "job.elsewhere": "ನಿಮ್ಮ ಇನ್ನೊಂದು ಫೋನ್ ಈ ಕೆಲಸಕ್ಕೆ ಉತ್ತರಿಸುತ್ತಿದೆ. ಮುಂದೆ ನೋಡಲು ಅಲ್ಲೇ GigSync ತೆರೆಯಿರಿ.",
    "job.contact": "ಸಂಪರ್ಕ, ಇಬ್ಬರೂ ಸಹಿ ಮಾಡಿದ ನಂತರವೇ",
    "job.asks": "ಕೆಲಸಗಾರರು ಕೇಳುತ್ತಿದ್ದಾರೆ: {question}",
    "job.send_answers": "ಉತ್ತರ ಕಳುಹಿಸಿ",
    "job.reached": "ನಿಮ್ಮ ಏಜೆಂಟ್ ತಲುಪಿದ ಬೆಲೆ: {price}.",
    "job.sign": "{price} ಬೆಲೆಗೆ ಸಹಿ ಮಾಡಿ",
    "job.decline": "ನಿರಾಕರಿಸಿ",
    "job.start_work": "ತಲುಪಿ ಕೆಲಸ ಶುರು ಮಾಡಿ",
    "job.mark_done": "ಕೆಲಸ ಮುಗಿಸಿದ್ದೇನೆ",
    "job.ask_payment": "ಹಣ ಕೇಳಿ",
    "lang.en": "ಇಂಗ್ಲಿಷ್",
    "lang.hi": "ಹಿಂದಿ",
    "lang.kn": "ಕನ್ನಡ",
    "flag.yes": "ಹೌದು",
    "flag.no": "ಇಲ್ಲ",
    "plan.title": "ನಿಮ್ಮ ಏಜೆಂಟ್‌ನ ಪ್ಲಾನ್, ನಿಮ್ಮ ಫೋನ್‌ನಲ್ಲಿ ಮಾತ್ರ",
    "approve.title": "ಏಜೆಂಟ್ ಬೆಲೆ ಹೇಳುವ ಮೊದಲು ನೋಡಿ",
    "approve.flagged": "ಇವನ್ನು ಮೊದಲು ನೋಡಬೇಕೆಂದು ನೀವು ಹೇಳಿದ್ದೀರಿ: {items}.",
    "approve.yes": "{price} ಬೆಲೆಯಿಂದ ಮುಂದುವರಿಸಿ",
    "approve.no": "ಈ ಕೆಲಸ ಬೇಡ",
    "trade.electrician": "ಎಲೆಕ್ಟ್ರಿಷಿಯನ್",
    "trade.plumber": "ಪ್ಲಂಬರ್",
    "trade.maid": "ಮನೆಗೆಲಸದವರು",
    "trade.carpenter": "ಬಡಗಿ",
    "trade.ac_technician": "ಎಸಿ ಮೆಕ್ಯಾನಿಕ್",
    "trade.painter": "ಪೇಂಟರ್",
    "trade.cook": "ಅಡುಗೆಯವರು",
    "trade.driver": "ಡ್ರೈವರ್",
    "area.indiranagar": "ಇಂದಿರಾನಗರ",
    "area.koramangala": "ಕೋರಮಂಗಲ",
    "area.hsr_layout": "ಎಚ್‌ಎಸ್‌ಆರ್ ಲೇಔಟ್",
    "area.jayanagar": "ಜಯನಗರ",
    "area.whitefield": "ವೈಟ್‌ಫೀಲ್ಡ್",
    "city.bengaluru": "ಬೆಂಗಳೂರು",
    "update.on_my_way": "ನಾನು ದಾರಿಯಲ್ಲಿದ್ದೇನೆ",
    "update.started": "ಕೆಲಸ ಶುರು ಮಾಡಿದ್ದೇನೆ",
    "update.done": "ಕೆಲಸ ಮುಗಿಯಿತು",
    "update.delayed": "ಸ್ವಲ್ಪ ತಡವಾಗುತ್ತಿದೆ",
    "pay.thread.requested": "ಕೇಳಲಾಗಿದೆ",
    "pay.thread.paid": "ಪಾವತಿಸಲಾಗಿದೆ",
    "pay.thread.confirmed": "ಖಚಿತ",
    "pay.thread.disputed": "ವಿವಾದದಲ್ಲಿದೆ",
    "job.payment": "ಪಾವತಿ {price}: {status}",
    "job.utr": "ಯುಪಿಐ ರೆಫ್ {utr}",
    "job.customer_paid": "ಗ್ರಾಹಕರು {price} ಪಾವತಿಸಿದ್ದೇವೆ ಎನ್ನುತ್ತಿದ್ದಾರೆ.",
    "job.money_received": "ಹಣ ಬಂತು",
    "job.not_received": "ಬಂದಿಲ್ಲ",
    "job.pay_by_upi": "{price} ಯುಪಿಐ ಮೂಲಕ ಪಾವತಿಸಿ",
    "job.open_upi": "ಯುಪಿಐ ಆ್ಯಪ್‌ನಲ್ಲಿ ತೆರೆಯಿರಿ",
    "job.utr_placeholder": "12 ಅಂಕಿಯ ಯುಪಿಐ ರೆಫರೆನ್ಸ್",
    "job.paid": "ನಾನು ಪಾವತಿಸಿದ್ದೇನೆ",
    "job.review_placeholder": "ಕೆಲಸ ಹೇಗಿತ್ತು?",
    "job.send_review": "ಅಭಿಪ್ರಾಯ ಕಳುಹಿಸಿ",
    "job.note_placeholder": "ಗ್ರಾಹಕರಿಗೆ ಚಿಕ್ಕ ಸಂದೇಶ",
    "job.send_note": "ಸಂದೇಶ ಕಳುಹಿಸಿ",
};
//# sourceMappingURL=job.js.map